import "core-js/modules/es.array.push.js";
export default {
  name: 'MenuItem',
  functional: true,
  props: {
    icon: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    }
  },
  render: function render(h, context) {
    var _context$props = context.props,
      icon = _context$props.icon,
      title = _context$props.title;
    var _ref = context.data || {},
      style = _ref.style;
    var vnodes = [];
    if (icon) {
      vnodes.push(h("svg-icon", {
        "attrs": {
          "icon-class": icon
        },
        "class": context.data.class
      }));
    }
    if (title) {
      vnodes.push(h("span", {
        "slot": 'title',
        "class": context.data.class,
        "style": {
          marginLeft: '5px'
        }
      }, [title]));
    }
    return vnodes;
  }
};